import { z } from 'zod'
import { zId, zMoney } from './scalars'

export const zShiftSummary = z.object({
  cash: zMoney,
  card: zMoney,
  qpay: zMoney,
  other: zMoney,
  total: zMoney,
  orderCount: z.number().int()
})

export const zShiftView = z.object({
  id: zId,
  staffId: zId,
  staffName: z.string(),
  status: z.enum(['active', 'closed']),
  openingFloat: zMoney,
  countedCash: zMoney.nullable(),
  expectedCash: zMoney,
  /** Null until somebody counts, which is not the same as zero. */
  variance: zMoney.nullable(),
  summary: zShiftSummary,
  startedAt: z.string(),
  endedAt: z.string().nullable(),
  note: z.string().nullable()
})

/**
 * Opening a shift.
 *
 * No `staffId` and no `pin`. Both used to be here and neither was load-bearing:
 * the server never checked the PIN, and it took the staff id from the input
 * rather than from anything it had verified. Who is opening the shift now comes
 * from the staff session, which is the only thing that proved a PIN.
 */
export const zStartShift = z.object({ openingFloat: zMoney })

export const zEndShift = z.object({
  shiftId: zId,
  countedCash: zMoney,
  note: z.string().max(500).optional()
})

export type ShiftView = z.infer<typeof zShiftView>
